<template>
  <TemplateLogin
    v-slot="{validate}"
    :error="errorMessage"
  >
    <h1 class="heading--medium">
      Reset Password
    </h1>
    <CalicoForm
      v-slot="{ field, error }"
      name="password"
      label="New Password"
      rules="required|password"
    >
      <CalicoField
        v-model="newPassword"
        v-bind="field"
        :type="showNewPassword ? 'text' : 'password'"
        :error="error"
        icon="eye"
        @click="showPasswordToggle($event, 'newPassword')"
      />
    </CalicoForm>
    <CalicoForm
      v-slot="{ field, error }"
      name="reTypePassword"
      label="Re-type Password"
      rules="required|confirmed:password"
    >
      <CalicoField
        v-model="retypePassword"
        v-bind="field"
        :type="showRetypePassword ? 'text' : 'password'"
        :error="error"
        icon="eye"
        @click="showPasswordToggle($event, 'retypePassword')"
      />
    </CalicoForm>
    <button
      class="button-primary"
      :disabled="loading"
      @click="resetPassword(validate)"
    >
      Save
    </button>
  </TemplateLogin>
</template>

<script>
import { auth } from '@/main'
import TemplateLogin from '@/components/template/login/index.vue'
import CalicoForm from '@/components/pattern/form/index.vue'
import CalicoField from '@/components/calico/field/index.vue'
import { flashMessage } from '@/utils/flashMessage'
import { confirmPasswordReset } from "firebase/auth";

export default {
    name: 'ResetPassword',
    components: {
        TemplateLogin,
        CalicoForm,
        CalicoField
    },
    data() {
        return {
            newPassword: "",
            retypePassword: "",
            showNewPassword: false,
            showRetypePassword: false,
            loading: false,
            errorMessage: "",
            flashMessage
        }
    },
    methods: {
        showPasswordToggle(e, type) {
            if (e.target.tagName.toLowerCase() === 'i') {
                this[`show${type.charAt(0).toUpperCase() + type.slice(1)}`] = !this[`show${type.charAt(0).toUpperCase() + type.slice(1)}`]
            }
        },
        async resetPassword(validate) {
            this.loading = true
            const oobCode = this.$route.query.oobCode
            try {
                const result = await validate();
                if (!result.valid) return;

                this.errorMessage = ""
                await confirmPasswordReset(auth, oobCode, this.newPassword)
                flashMessage.set("Password changed successfully!")
                this.$router.push({ path: '/login' })
            } catch (error) {
                this.errorMessage = error.message
            } finally {
                this.loading = false
            }
        }
    }
}
</script>